import { PlanInfo, Plan, Step, PreRequisiteStepError, Variable, ExecutePlanRequest } from './../model/Plan';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class PlanService {
  private url: string

  constructor(private http: HttpClient, private authService: AuthenticationService) {
    this.url = "/services/otsc-server/v1/managers/solution/";
  }

  getPlans(pageSize: number, solName: string, startIndex: number,  query: string = ''): Observable<HttpResponse<PlanInfo>> {
    let url = this.url + "getPlans";
    return this.http.get<PlanInfo>(url,
      {
        observe: 'response',
        params: {
          pageSize: pageSize.toString(),
          solName: solName,
          startIndex: startIndex.toString(),
          query: query
        }
      });
  }

  getPlan(planId: number): Observable<HttpResponse<Plan>> {
    let url = this.url + "getPlan/";
    return this.http.get<Plan>(url + planId, { observe: 'response' });
  }

  getDeploymentSteps(): Observable<HttpResponse<Step[]>> {
    let url = "/services/otsc-server/v1/managers/agent/getDeploymentSteps";
    return this.http.get<Step[]>(url, { observe: 'response' });
  }

  validatePlanName(envId:number, name: string): Observable<HttpResponse<boolean>> {
    let url = this.url + "validatePlanName";
    return this.http.get<boolean>(url, { observe: 'response', params: {envId: envId.toString(), name: name} });
  }

  savePlan(newPlan:Plan): Observable<HttpResponse<Plan>> {
    let url = this.url + "savePlan";

    return this.http.post<Plan>(url, JSON.stringify(newPlan), {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      observe: 'response'
    });
  }

  deletePlan(planIds:number[]): Observable<HttpResponse<boolean>> {
    let url = this.url + "deletePlan";
    let body = new URLSearchParams();

    planIds.forEach((planId: number) => {
        body.append('ids[]', planId.toString());
    });

    return this.http.post<boolean>(url, body.toString(), {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      observe: 'response'
    });
  }

  importPlan(newPlan:Plan, planFile:File){
    let url = "/services/otsc-server/v1/managers/upload/plan";
    const formData = new FormData();
    formData.append('name', newPlan.name);
    formData.append('description', newPlan.description);
    formData.append('environment', newPlan.selectedEnvironmentId.toString());
    formData.append('file', planFile);

    return this.http.post<any>(url, formData, {
      observe: 'response'
    });
  }

  runPrerequisiteChecks(planId:number, steps:Step[]): Observable<HttpResponse<PreRequisiteStepError[]>> {
    let url = this.url + "runPrerequisiteChecks";

    return this.http.post<PreRequisiteStepError[]>(url, 
                                                  JSON.stringify(steps), 
                                                  {headers: new HttpHeaders({ 'Content-Type': 'application/json;charset=UTF-8' }),
                                                      observe: 'response',
                                                      params: {
                                                        planId: planId.toString()
                                                      }
                                                    });
  }

  executePlan(planId:number, plan: ExecutePlanRequest): Observable<HttpResponse<any>> {
    let url = this.url + "executePlan";

    return this.http.post<any>(url, 
      JSON.stringify(plan),
       
      {headers: new HttpHeaders({ 'Content-Type': 'application/json;charset=UTF-8' }),
          observe: 'response',
          params: {
            planId: planId.toString()
          }
        });
  }
}
